import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import Solution from "@/components/Solution";
import Benefits from "@/components/Benefits";
import Process from "@/components/Process";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Offer from "@/components/Offer";
import Faq from "@/components/Faq";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-[#0A0E14] text-white">
      <Navbar />
      <Hero />
      <Marquee />
      <Problem />
      <Solution />
      <Benefits />
      <Process />
      <Gallery />
      <Testimonials />
      <Offer />
      <Faq />
      <QuoteForm />
      <Footer />
      <ChatWidget />
    </main>
  );
}
